import { createRoot } from 'react-dom/client';

import './main.css';

import { App } from './App';

(window as any).APP_VERSION = import.meta.env.VITE_APP_VERSION;

createRoot(document.getElementById('root') as HTMLElement).render(<App />);
